<template>
  <div v-if="row.hasContact == '1'||row.hascontact == '1'||row.contacts" style="position: relative;height: 38px;line-height: 38px;" :class="{'shortPhone':isShort}">
    <span :class="['select-none', 'phone-content',{'hq-phone-content':HQ}]" :title="row.contacts.split(/,|;/)[0].trim()" v-if="row.contacts && row.contacts.split(/,|;/)[0].trim().indexOf('http') != 0 ">
      <span v-if='row.contacts!="无联系方式"'>{{row.contacts.split(/,|;/)[0].trim()||row.contacts.split(/,|;/)[1].trim() }}</span>
      <!-- 新增特殊企业点击识别未无联系方式 -->
      <span class="select-none" style="color: var(--text-auxiliary-color);" v-if='row.contacts=="无联系方式"' >
        无联系方式
      </span>
    </span>
    <img referrerpolicy="no-referrer" v-else-if="row.contacts && row.contacts.split(/,|;/)[0].trim().indexOf('http') == 0" style="vertical-align: bottom;height:20px;vertical-align:-4px" :src="row.contacts.split(/,|;/)[0].trim()" alt="">
    <span v-else  class="unShow" :class="[{'shortPhone1':isShort},{'hq-unShow':HQ}]">
      <img src="../../assets/images/tabList/phone_hq.png" v-if="HQ">
      <!-- <img src="../../assets/images/tabList/phone.png" v-else> -->
      <span class="isvg" :key="Math.random()" v-else><img src="../../assets/images/tabList/newphone.svg" onload="SVGInject(this)" /></span>
      <label class="unShowLab">点击查看</label>
     <!--<label style="margin-left: 56px;cursor: pointer;">{{row.contactCount}}</label>
     <label style="font-size: 12px;margin-left: -5px; cursor: pointer;">个</label>-->
    </span>
    <!-- <span class="more" v-show="row.contacts && row.contacts.split(/,|;/)[0].trim().indexOf('http') != 0 "></span> -->
  </div>
  <div v-else style="position: relative;height: 38px;line-height: 38px;" :class="{'shortPhone':isShort}">
    <span class="select-none" style="color: var(--text-auxiliary-color);">
      无联系方式
    </span>
    <!-- <span class="more"></span> -->
  </div>
</template>
<script>
export default {
  props: ['row'],
  data() {
    return {
      isShort:false,
      HQ:__VERSION==='HQ'
    };
  },
  created(){
    this.isShort = (this.$route.path=='/pool')?true:false;
  }
};
</script>
<style lang="scss" scoped>
.more {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url('../../assets/images/tabList/more.png') no-repeat center;
  position: absolute;
  right:5px;
  top: 50%;
  margin-top: -8px;
  &:hover{
    background: url('../../assets/images/tabList/more_click.png') no-repeat center;
  }
}
.phone-content {
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  vertical-align: bottom;
  color:var(--theme-color);
  &.hq-phone-content{
  color:#337ab7;
&:hover{
  color:#23527c;

}
  }
}
.unShow{
  display: inline-block;
  margin-left: -6px;
  width: 123px;
  height: 38px;
  color: var(--theme-color) ;
  font-size: 20px;
  line-height: 38px;
  position: relative;
  // background: url('../../assets/images/tabList/phonebg.png') no-repeat center;
  background: url('../../assets/images/tabList/phonebgNew.png') no-repeat center;
  cursor: pointer;
  margin-top: -1px;
  &.hq-unShow{
  background: url('../../assets/images/tabList/phonebg_hq.png') no-repeat center;
  margin-top: 0px;
  color: #337ab7;
  }
  img{
    display: inline-block;
    position: absolute;
    left: 20px;
    top:9px;
    cursor: pointer;
  }
  label.unShowLab{
    display: inline-block;
    cursor: pointer;
    font-size: 14px;
    position: absolute;
    left: 50px;
    top:1px;
  }

}
.unShow:hover{
  color: var(--theme-color);
  // background: url('../../assets/images/tabList/phonebg_click.png') no-repeat center;
  background: url('../../assets/images/tabList/phonebgNew_click.png') no-repeat center;
}
.hq-unShow:hover{
  color: #23527c;
  background: url('../../assets/images/tabList/phonebg_click_hq.png') no-repeat center;
}
.shortPhone{
  margin-left: 0 !important;
}
.shortPhone1{
  margin-left: 1px;
}
.isvg {
  width : 20px;
  height : 20px;
  fill: var(--theme-color);
  margin-left: 20px;
  margin-top: 10px;
}
</style>





// WEBPACK FOOTER //
// src/components/global/phone.vue